<template lang="html">
  <div id="services-page">

    <section class="main-section">
      <div class="container">
        <h1 class="page-title">Servicios</h1>

        <div class="row justify-content-between">
          <!-- <div class="col-md-6 col-lg-4 col-service">
            <p class="mb-2 text-center">
              <img class="icon" src="public/images/pages/services/icon-1.png">
            </p>
            <h5>Clientes consentidos</h5>
            <p>
              Realizamos una rifa mensual para nuestros clientes mas consentidos. Suscríbete a la rifa aquí y participa por los mejores premios. Los ganadores se publican vía Facebook, WhatsApp y nuestro mostrador.
            </p>
          </div> -->

          <div class="col-md-6 col-lg-4 col-service">
            <p class="mb-2 text-center">
              <img class="icon" src="public/images/pages/services/icon-4.png">
            </p>
            <h5>Asesoria</h5>
            <p>
              Sabemos lo desesperante que es no poder encontrar una refacción, nuestros asesores te pueden ayudar a encontrar la pieza exacta. Solo necesitas tener a la mano los siguientes datos Modelo, Motor, Año y Pieza del vehículo. En caso de ser material por metro únicamente se requiere el área a cubrir.
            </p>
          </div>

          <router-link class="col-md-6 col-lg-4 col-service" target="_blank" to="/garantia">
            <p class="mb-2 text-center">
              <img class="icon" src="public/images/pages/services/icon-5.png">
            </p>
            <h5>Garantia</h5>
            <p>
              Todos nuestros productos tienen garantía.<br />
              Si requieres reclamar la garantía de un producto por defecto o malfuncionamiento envíanos tu información <u>aquí</u> para solucionarlo lo antes posible.
            </p>
          </router-link>

          <div class="col-md-6 col-lg-4 col-service">
            <p class="mb-2 text-center">
              <img class="icon" src="public/images/pages/services/icon-3.png">
            </p>
            <h5>Compra por WhatsApp</h5>
            <p>
              Hules Becerra siempre de la mano con la tecnología te permite hacer pedidos por WhatsApp. Agréganos; <a href="tel:3317283818">33 1728 3818</a> o <a href="tel:3317283112">33 1728 3112</a> y especifícanos lo que necesitas. Nuestro personal esta listo para ayudarte.
            </p>
          </div>

          <div class="col-md-6 col-lg-4 col-service">
            <p class="mb-2 text-center">
              <img class="icon" src="public/images/pages/services/icon-2.png">
            </p>
            <h5>Envios foraneos</h5>
            <p>
              A través de tu pedido en línea puedes generar la guía para que llegue hasta la puerta de tu hogar, negocio o taller nuestro producto.
            </p>
          </div>

          <div class="col-md-6 col-lg-4 col-service">
            <p class="mb-2 text-center">
              <img class="icon" src="public/images/pages/services/icon-7.svg">
            </p>
            <h5>Click & Collect</h5>
            <p>
              ¡Compra desde la comodidad de tu hogar y recoge en nuestra tienda! Selecciona tus productos, elige la opción de recogida y en poco tiempo tendrás tus compras listas para llevar.
            </p>
          </div>

          <div class="col-md-6 col-lg-4 col-service">
            <p class="mb-2 text-center">
              <img class="icon" src="public/images/pages/services/icon-6.png">
            </p>
            <h5>Servicio exprés en ZMG</h5>
            <p>
              A través de plataformas de reparto hacemos llegar el producto a tu domicilio de manera exprés máximo 90 minutos.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="payments-section">
      <div class="container">
        <div class="row">
          <div class="col-12 col-title">
            <h2>Aceptamos pagos en</h2>
          </div>

          <div class="col-12 col-logos">
            <div class="box-logo">
              <div class="inside">
                <img src="public/images/pages/services/oxxo.png">
              </div>
            </div>

            <div class="box-logo">
              <div class="inside">
                <img src="public/images/pages/services/payments.png">
              </div>
            </div>

            <div class="box-logo">
              <div class="inside">
                <img src="public/images/pages/services/mercado.png">
              </div>
            </div>

            <div class="box-logo">
              <div class="inside">
                <img src="public/images/pages/services/transferencia.png">
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
}
</script>
